import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
import { Lock } from 'lucide-react';
export function CTASection() {
  return <section className="relative py-[80px] md:py-[120px] px-6 flex items-center justify-center overflow-hidden" data-id="element-8">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-9">
        <img src="https://images.unsplash.com/photo-1609220136736-443140cffec6?w=1920&q=80" alt="Familia multigeneracional feliz" className="w-full h-full object-cover object-center blur-[2px]" data-id="element-10" />
        <div className="absolute inset-0 bg-brand-black/80" data-id="element-11"></div>
        {/* Subtle gold glow */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand-gold/10 rounded-full blur-[120px] pointer-events-none" data-id="element-12"></div>
      </div>

      <div className="relative z-10 max-w-[900px] mx-auto text-center w-full" data-id="element-13">
        <FadeIn data-id="element-14">
          <h2 className="text-[38px] md:text-[48px] font-bold text-white mb-6 leading-tight drop-shadow-lg" data-id="element-15">
            Dale a Tu Familia <br data-id="element-16" />
            El Regalo Más Grande: <br className="md:hidden" data-id="element-17" />
            <span className="text-brand-gold" data-id="element-18">La Paz.</span>
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-19">
          <p className="text-[20px] md:text-[24px] text-brand-gold font-semibold max-w-2xl mx-auto mb-12 drop-shadow-md" data-id="element-20">
            Aprobación en menos de 10 minutos. <br className="md:hidden" data-id="element-21" />
            Sin exámenes. Sin complicaciones.
          </p>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-22">
          <div className="flex flex-col items-center space-y-6" data-id="element-23">
            <Button pulse={true} className="min-w-[300px] md:min-w-[400px] text-[20px] md:text-[24px] py-5" onClick={() => document.getElementById('formulario')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-24">
              👇 QUIERO PROTEGER A MI FAMILIA AHORA
            </Button>

            <div className="flex items-center justify-center gap-2 text-[16px] text-brand-lightGray bg-black/40 px-6 py-2 rounded-full backdrop-blur-sm border border-white/10" data-id="element-25">
              <Lock className="w-4 h-4 text-brand-gold" data-id="element-26" />
              <span data-id="element-27">100% Seguro | Sin Riesgo | Aprobación Garantizada</span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}